import { render, staticRenderFns } from "./entity-form.vue?vue&type=template&id=ef0d973a&"
import script from "./entity-form.vue?vue&type=script&lang=js&"
export * from "./entity-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports